import { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import CustomModal from './components/CustomModal';
import { getTenantList, deleteTenantById } from './components/services';
import { FaEdit, FaPlus, FaTrash } from 'react-icons/fa';
import { updateTenantByOrgID } from './components/services';
import './components/Tenants.css';

function Tenants() {
    const [tenants, setTenants] = useState<any[]>([]);
    const [showModal, setShowModal] = useState(false);
    const [selectedTenant, setSelectedTenant] = useState<any | null>(null);
    const [currentPage, setCurrentPage] = useState(1);
    const tenantsPerPage = 10;

    useEffect(() => {
        refreshTenantList();
    }, []);

    const refreshTenantList = () => {
        getTenantList()
            .then((res: { data: { tenants: any[]; }; }) => {
                setTenants(res.data.tenants);
            })
            .catch((error: any) => {
                console.error("Error fetching tenant list:", error);
            });
    };

    const indexOfLastTenant = currentPage * tenantsPerPage;
    const indexOfFirstTenant = indexOfLastTenant - tenantsPerPage;
    const currentTenants = tenants.slice(indexOfFirstTenant, indexOfLastTenant);

    const paginate = (pageNumber: number) => setCurrentPage(pageNumber);

    const handleEdit = (tenant: any) => {
        Swal.fire({
            title: 'Edit Tenant Name',
            input: 'text',
            inputLabel: 'New Name',
            inputValue: tenant.Name,
            showCancelButton: true,
            confirmButtonText: 'Save',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
            preConfirm: (newName) => {
                if (!newName) {
                    Swal.showValidationMessage('Please enter a new name');
                } else {
                    return newName;
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                const updatedTenant = { name: result.value };

                updateTenantByOrgID(tenant.OrgID, updatedTenant)
                    .then(() => {
                        Swal.fire('Saved!', 'Tenant name has been updated.', 'success');
                        refreshTenantList();
                    })
                    .catch((error: any) => {
                        Swal.fire('Error!', 'There was an error updating the tenant.', 'error');
                        console.error('Error updating tenant:', error);
                    });
            }
        });
    };

    const handleDelete = (tenant: any) => {
        Swal.fire({
            title: `Are you sure you want to delete tenant "${tenant.Name}"?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            reverseButtons: true,
        }).then((result) => {
            if (result.isConfirmed) {
                deleteTenantById(tenant.id)
                    .then(() => {
                        Swal.fire('Deleted!', 'Tenant has been deleted.', 'success');
                        refreshTenantList();
                    })
                    .catch((error: any) => {
                        Swal.fire('Error!', 'There was an error deleting the tenant.', 'error');
                        console.error('Error deleting tenant:', error);
                    });
            }
        });
    };

    const handleOpenModal = () => {
        setSelectedTenant(null);
        setShowModal(true);
    };

    const totalPages = Math.ceil(tenants.length / tenantsPerPage);

    return (
        <>
            <div className='card'>
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='f-titulo text-marino fs-md'>Tenant List</span>
                    </h3>

                    <div className='card-toolbar'>
                        <button
                            onClick={handleOpenModal}
                            className='btn-light-marino f-parrafo d-flex align-items-center'
                        >
                            <FaPlus style={{ marginRight: '0.5rem' }} />
                            New Tenant
                        </button>
                    </div>
                </div>

                <div className='card-body py-3'>
                    <div className='tab-content'>
                        <div className='tab-pane fade show active' id='kt_table_widget_5_tab_1'>
                            <div className='table-responsive'>
                                <table className='w-full f-parrafo caption-bottom custom-table' id='table'>
                                    <thead className="text-azul text-left">
                                        <tr>
                                            <th className='table-cell'>ID</th>
                                            <th className='table-cell'>Name</th>
                                            <th className='table-cell'>Org ID</th>
                                            <th className='table-cell'>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTenants.length === 0 ? (
                                            <tr>
                                                <td colSpan={5} className="text-center">
                                                    <span className='text-pink fw-bold fs-p'>No Data Available</span>
                                                </td>
                                            </tr>
                                        ) : (
                                            currentTenants.map((tenant: any, index: number) => (
                                                <tr key={index} className='table-row'>
                                                    <td className='table-cell'>{tenant.id}</td>
                                                    <td className='table-cell'>{tenant.Name}</td>
                                                    <td className='table-cell'>{tenant.OrgID}</td>
                                                    <td className='table-cell'>
                                                        <div className='actions-buttons'>
                                                            <button
                                                                className='btn btn-light btn-sm d-flex align-items-center'
                                                                onClick={() => handleEdit(tenant)}
                                                            >
                                                                <FaEdit style={{ marginRight: '0.3rem' }} />
                                                                Edit
                                                            </button>
                                                            <button
                                                                className='btn btn-light btn-sm d-flex align-items-center'
                                                                onClick={() => handleDelete(tenant)}
                                                            >
                                                                <FaTrash style={{ marginRight: '0.3rem' }} />
                                                                Delete
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>

                                <div className='pagination-container d-flex justify-content-end mt-3'>
                                    {[...Array(totalPages)].map((_, i) => (
                                        <button
                                            key={i + 1}
                                            onClick={() => paginate(i + 1)}
                                            className={`page-item btn btn-sm mx-1 ${currentPage === i + 1 ? 'btn-primary' : 'btn-secondary'}`}
                                        >
                                            {i + 1}
                                        </button>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {showModal && (
                <CustomModal
                    show={showModal}
                    handleClose={() => setShowModal(false)}
                    title={
                        <span className="d-flex align-items-center">
                            <FaPlus style={{ marginRight: '0.5rem' }} />
                            Create New Tenant
                        </span>
                    }
                    tenantDetails={selectedTenant}
                    onSave={refreshTenantList}
                />
            )}
        </>
    );
}

export default Tenants;
